import { useEffect, useState } from "react";
import type { Event } from "@mvk/shared";
import { adminEventsService } from "../../services/adminEventsService";

export function useAdminEvent(eventId: string | undefined) {
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(Boolean(eventId));

  useEffect(() => {
    if (!eventId) {
      setEvent(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    adminEventsService
      .getById(eventId)
      .then((e) => {
        if (!cancelled) setEvent(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return { event, loading };
}
